export const SET_EXHIBITED_ON_THIS_FLOOR = "SET_EXHIBITED_ON_THIS_FLOOR";
export const SET_EXHIBITED_ON_THIS_FLOOR_ERR = "SET_EXHIBITED_ON_THIS_FLOOR_ERR";
export const SHOW_LOADING = "SHOW_LOADING";